angular
  .module('company')

  .directive('documentForm', function() {
    return {
      restrict: 'E',
      replace: true,
      require: '^ngModel',
      scope: {
        company: '=ngModel',
        save: '&',
        undo: '&'
      },
      templateUrl: 'custom/company/views/partials/documentForm.html'
    };
  });
